import { UI } from '../nextpage';

export class SliderCards {
    constructor(private NP: UI) {
        // Cards Slider
        const slideToCurrentCard = (cardSlider: HTMLDivElement): void => {
            const sliderRef = cardSlider.dataset.sliderRef;
            const sliderInfo = this.NP.properties.sliderInfo[sliderRef];
            const cardContainer = cardSlider.querySelectorAll(".cards")[0] as HTMLDivElement;

            if (!cardContainer.classList.contains("allow-animation")) {
                cardContainer.classList.toggle("allow-animation", true);
                cardContainer.classList.toggle("d-none", false);
            }
            [].forEach.call(cardSlider.querySelector(".dots").children, (dot: HTMLButtonElement , i: number) => {
                if (dot.nodeName !== "BUTTON") {
                    return;
                }
                this.NP.toggleAriaState(dot, "pressed", i === sliderInfo.currentCard);
            });
            cardContainer.style.transform = "translateX(" + (sliderInfo.slideCards[sliderInfo.currentCard] + sliderInfo.translateStart) + "px)";
        };
        const transformTest = (cardSlider: HTMLDivElement, targetCard: number): void => {
            const sliderRef = cardSlider.dataset.sliderRef;
            const sliderInfo = this.NP.properties.sliderInfo[sliderRef];

            const lastCardIndex = sliderInfo.cardCount - 1;
            let baseTransform = 0;
            const cardAndGutter = sliderInfo.cardWidth + sliderInfo.cardGutter;

            if (sliderInfo.currentCard === lastCardIndex && targetCard === 0) {
                baseTransform = cardAndGutter * (sliderInfo.visibleCards - 1);
            } else if (sliderInfo.currentCard === 0 && targetCard === lastCardIndex) {
                baseTransform = cardAndGutter * (sliderInfo.cardCount + sliderInfo.visibleCards);
            }
            if (baseTransform !== 0) {
                const cardContainer = cardSlider.querySelectorAll(".cards")[0] as HTMLDivElement;
                cardContainer.classList.toggle("allow-animation", false);
                cardContainer.style.transform = "translateX(" + (-baseTransform + sliderInfo.translateStart) + "px)";
                cardContainer.offsetHeight; // We need to add this in order to trigger a reflow (fully pausing the animation in the transform property)
            }
        };
        const autoCardSlider = window.setInterval(() => {
            const sliders = document.querySelectorAll(".slider");
            const cardSliders = [].filter.call(sliders, (slider: HTMLDivElement) => { return (slider.classList.contains("cards") && !slider.classList.contains("disable-auto-rotate")); });
            if (cardSliders.length === 0) {
                window.clearInterval(autoCardSlider);
                return;
            }
            cardSliders.forEach((slider: HTMLDivElement) => {
                const sliderRef = slider.dataset.sliderRef;
                const sliderInfo = this.NP.properties.sliderInfo[sliderRef];

                const lastCardIndex = sliderInfo.cardCount - 1;
                const targetCard = sliderInfo.currentCard === lastCardIndex ? 0 : sliderInfo.currentCard + 1;

                transformTest(slider, targetCard);

                sliderInfo.currentCard = targetCard;
                slideToCurrentCard(slider);
            });
        }, this.NP.options.slideRotationInterval);
        this.NP.registerEvent("cardSliderMenuClick", (e: Event) => {
            if (e.target === undefined || e.target === null) {
                return;
            }
            const clicked = e.target as HTMLElement;
            const parentSlider = clicked.parentElement as HTMLDivElement;
            const sliderRef = parentSlider.dataset.sliderRef;
            const sliderInfo = this.NP.properties.sliderInfo[sliderRef];

            parentSlider.classList.toggle("disable-auto-rotate", true);

            const lastCardIndex = sliderInfo.cardCount - 1;
            const targetCard = clicked.classList.contains("icon-menu-left")
                ? (sliderInfo.currentCard === 0 ? lastCardIndex : sliderInfo.currentCard - 1)
                : (sliderInfo.currentCard === lastCardIndex ? 0 : sliderInfo.currentCard + 1);

            transformTest(parentSlider, targetCard);

            sliderInfo.currentCard = targetCard;
            slideToCurrentCard(parentSlider);
        });
        this.NP.registerEvent("cardSliderPageDotClick", (e: Event) => {
            if (e.target === undefined || e.target === null) {
                return;
            }
            const clicked = e.target as HTMLElement;
            const parentSlider = clicked.closest(".slider.cards") as HTMLDivElement;
            const sliderRef = parentSlider.dataset.sliderRef;
            const sliderInfo = this.NP.properties.sliderInfo[sliderRef];
            const currentDot = e.target;
            let targetCard = 0;

            [].forEach.call(clicked.parentElement.children, (dot: HTMLButtonElement , i: number) => {
                if (dot !== currentDot) {
                    return;
                }
                targetCard = i;
            });
            parentSlider.classList.toggle("disable-auto-rotate", true);

            transformTest(parentSlider, targetCard);

            sliderInfo.currentCard = targetCard;
            slideToCurrentCard(parentSlider);
        });
        this.NP.registerEvent("cardSliderSwipeStart", (e: TouchEvent) => {
            if (!this.NP.properties.isMobile && !this.NP.properties.isTablet) {
                return;
            }
            const startTime = new Date().getTime();
            // Get all touch positions so we can support multi-touch
            const totalStartTouches = e.targetTouches.length;

            const startTouchPositions = {};
            for(let i = 0; i < totalStartTouches; i++) {
                // Store the X positions of the starting touch points by their touch identifier
                startTouchPositions[e.targetTouches[i].identifier] = e.targetTouches[i].screenX;
            }
            const touched = e.target as HTMLElement;
            const parentSlider = touched.closest(".slider") as HTMLDivElement;
            const sliderRef = parentSlider.dataset.sliderRef;
            const sliderInfo = this.NP.properties.sliderInfo[sliderRef];
            sliderInfo.lastTouchStartTime = startTime;
            sliderInfo.lastTouchStartPositions = startTouchPositions;
        });
        this.NP.registerEvent("cardSliderSwipeEnd", (e: TouchEvent) => {
            if (!this.NP.properties.isMobile && !this.NP.properties.isTablet) {
                return;
            }
            const endTime = new Date().getTime();
            const touched = e.target as HTMLElement;
            const parentSlider = touched.closest(".slider") as HTMLDivElement;
            const sliderRef = parentSlider.dataset.sliderRef;
            const sliderInfo = this.NP.properties.sliderInfo[sliderRef];

            const swipeTimeDelta = endTime - sliderInfo.lastTouchStartTime;
            if (swipeTimeDelta < 100) {
                return;
            }
            const totalEndTouches = e.changedTouches.length;

            let swipeDistanceDelta = -1;
            let directionSenseLeft = 0;
            let directionSenseRight = 0;
            for(let i = 0; i < totalEndTouches; i++) {
                const touchMatch = sliderInfo.lastTouchStartPositions.hasOwnProperty(e.changedTouches[i].identifier);
                if (!touchMatch) {
                    continue;
                }
                const startTouchX = sliderInfo.lastTouchStartPositions[e.changedTouches[i].identifier];
                const thisDelta = e.changedTouches[i].screenX - startTouchX;
                if (thisDelta < 0) {
                    directionSenseRight++;
                } else {
                    directionSenseLeft++;
                }
                const absDelta = Math.abs(thisDelta) / window.screen.width;
                if (absDelta <= swipeDistanceDelta) {
                    continue;
                }
                swipeDistanceDelta = absDelta;
            }
            /**
            * Do nothing if any of the following conditions occur:
            * - The time delta between touch start/end is not a number (bad/goofy conversion, or doesn't exist)
            * - The swipe distance was not detected (e.g. no matching touch identifiers were found or the touches didn't move)
            * - Sense of direction could not be determined (in the strange case where an equal amount of touch events move left and right)
            * - The distance moved does not meet our minimum swipe threshold
            */
            if (isNaN(swipeTimeDelta) || swipeDistanceDelta === -1 || directionSenseLeft === directionSenseRight || swipeDistanceDelta < this.NP.options.swipeDistanceThreshold) {
                return;
            }
            const menuIcon = parentSlider.querySelector(".icon-menu-" + (directionSenseRight > directionSenseLeft ? "right" : "left"));
            if (menuIcon === null) {
                return;
            }
            menuIcon.dispatchEvent(new Event("click"));
        });
        const cardSliderResize = (): void => {
            document.querySelectorAll(".slider.cards").forEach((slider: HTMLDivElement) => {
                const sliderInfo = this.NP.properties.sliderInfo[slider.dataset.sliderRef];
                if (!this.NP.properties.isMobile && !this.NP.properties.isTablet) {
                    sliderInfo.translateStart = 0;
                } else {
                    const sliderWidth = slider.clientWidth;
                    const twoWidth = (sliderInfo.cardWidth * 2) + sliderInfo.cardGutter;
                    const translateAmount = (sliderWidth < twoWidth || this.NP.properties.isMobile) ? (sliderWidth - sliderInfo.cardWidth) / 2 : 0;
                    sliderInfo.translateStart = translateAmount;
                }
                
                const cards = slider.querySelectorAll(".cards")[0] as HTMLDivElement;
                cards.classList.toggle("allow-animation", false);
                cards.style.transform = "translateX(" + (sliderInfo.slideCards[sliderInfo.currentCard] + sliderInfo.translateStart) + "px)";
                cards.offsetHeight; // We need to add this in order to trigger a reflow (fully pausing the animation in the transform property)
            });
        };
        this.NP.components.cardSlider = (selector: string | Element | NodeListOf<Element> | Array<Element>): void => {
            const cardSliders = this.NP.getComponentSelector(selector);
            cardSliders.forEach((cardSlider: HTMLDivElement, i: number) => {
                const sliderRef = "cards" + i;
                const sliderWidth = cardSlider.clientWidth;
                const cards = [].filter.call(cardSlider.children, (card: HTMLDivElement) => { return card.classList.contains("card"); });

                // Set the starting containers and sort things into the right places.
                const cardContainer = document.createElement("div");
                    cardContainer.classList.add("cards");
                    cards.forEach((card: HTMLDivElement) => { cardContainer.appendChild(card); });
                const sliderWrap = document.createElement("div");
                    sliderWrap.classList.add("slider-wrap");
                    sliderWrap.appendChild(cardContainer);
                const menuLeft = document.createElement("div");
                    menuLeft.classList.add("icon-menu-left");
                    menuLeft.addEventListener("click", (e: Event) => this.NP.events.cardSliderMenuClick(e));
                const menuRight = document.createElement("div");
                    menuRight.classList.add("icon-menu-right");
                    menuRight.addEventListener("click", (e: Event) => this.NP.events.cardSliderMenuClick(e));

                cardSlider.appendChild(sliderWrap);
                cardSlider.appendChild(menuLeft);
                cardSlider.appendChild(menuRight);

                const pageDots = document.createElement("div");
                    pageDots.classList.add("dots");
                const slideCards: Array<number> = [];

                // Determine the starting card dimension information
                const cardBaseCount = cards.length;
                this.NP.setCssVariable(cardSlider, "--np-slider-card-count-base", cardBaseCount);

                let cardWidth = this.NP.getCssDimension(this.NP.getCssVariable(cardSlider, "--np-slider-card-width"));
                let cardHeight = this.NP.getCssDimension(this.NP.getCssVariable(cardSlider, "--np-slider-card-height"));
                const cardGutter = this.NP.getCssDimension(this.NP.getCssVariable(cardSlider, "--np-slider-card-gutter"));

                // Find out if we're given custom card dimensions
                const cardWidthData = this.NP.getCssDimension(cardSlider.dataset.cardWidth) || -1;
                const cardHeightData = this.NP.getCssDimension(cardSlider.dataset.cardHeight) || -1;
                
                // Only use the card width data if we see a positive number (meaning a valid dimension was found)
                if (cardWidthData > 0) {
                    // If it's less than 1 we treat it as a floating percentage with the basis being the width of the slider element
                    if (cardWidthData < 1) {
                        cardWidth = Math.floor(cardWidthData * sliderWidth);
                    // Otherwise we assume it's a pixel amount
                    } else if (cardWidthData < (sliderWidth / 2 - 11)) {
                        cardWidth = Math.floor(cardWidthData);
                    }
                    this.NP.setCssVariable(cardSlider, "--np-slider-card-width", cardWidth + "px");
                }
                
                if (cardHeightData > 0) {
                    cardHeight = cardHeightData;
                    this.NP.setCssVariable(cardSlider, "--np-slider-card-height", cardHeightData + "px");
                }

                // Determine how many cards are visible given the current dimensions of the slider
                const visibleCards = Math.ceil(sliderWidth / (cardWidth + cardGutter));

                // Set the total cards behind the scenes equal to the base # of cards plus double the cloned cards
                // Why double? Because we will clone both the start & end cards in the slider.
                const totalCards = cardBaseCount + (visibleCards * 2);
                const cardWidthPlusMargin = cardWidth + cardGutter;
                const startingLeft = cardWidthPlusMargin * visibleCards;
                
                this.NP.setCssVariable(cardSlider, "--np-slider-card-count-total", totalCards);

                cards.forEach((j: number) => {
                    const slideCardCount = slideCards.length;
                    const slideAmount = (cardWidthPlusMargin * -slideCardCount) - startingLeft;
                    slideCards[slideCardCount] = slideAmount;
                    const dotButton = document.createElement("button");
                        dotButton.type = "button";
                        dotButton.setAttribute("role", "button");
                        dotButton.tabIndex = 0;
                        this.NP.toggleAriaState(dotButton, "pressed", j === 0);
                        dotButton.innerText = "slide " + (j + 1);
                        dotButton.addEventListener("click", (e: Event) => this.NP.events.cardSliderPageDotClick(e));
                    pageDots.appendChild(dotButton);
                });

                const headCards: Array<HTMLDivElement> = [];
                const tailCards: Array<HTMLDivElement> = [];
                
                cards.forEach((card: HTMLDivElement, c: number) => {
                    if (c < visibleCards) {
                        const headCard = card.cloneNode(true) as HTMLDivElement;
                        headCard.classList.toggle("head", true);
                        headCards[headCards.length] = headCard;
                    }
                    if (c >= (cardBaseCount - visibleCards)) {
                        const tailCard = card.cloneNode(true) as HTMLDivElement;
                        tailCard.classList.toggle("tail", true);
                        tailCards[tailCards.length] =tailCard;
                    }
                });

                cardContainer.append(...headCards);
                cardContainer.prepend(...tailCards);
                cardContainer.classList.toggle("d-none", true);

                const twoWidth = (cardWidth * 2) + cardGutter;
                let translateAmount = 0;

                // If the slider width is less than the width of two cards, we'll center one card on the screen at a time.
                if (sliderWidth < twoWidth || this.NP.properties.isMobile) {
                    translateAmount = (sliderWidth - cardWidth) / 2;
                }
                cardContainer.style.transform = "translateX(" + (slideCards[0] + translateAmount) + "px)";

                this.NP.properties.sliderInfo[sliderRef] = {
                    "cardCount": cardBaseCount,
                    "visibleCards": visibleCards,
                    "cardWidth": cardWidth,
                    "cardGutter": cardGutter,
                    "slideCards": slideCards,
                    "translateStart": translateAmount,
                    "currentCard": 0
                };

                cardContainer.classList.toggle("d-none", false);
                cardSlider.appendChild(pageDots);
                pageDots.style.display = "block";
                cardSlider.style.maxHeight = (cardHeight + pageDots.clientHeight + 2) + "px";
                pageDots.style.display = "";
                cardSlider.dataset.sliderRef = sliderRef;

                cardSlider.addEventListener("touchstart", (e: Event) => this.NP.events.cardSliderSwipeStart(e));
                cardSlider.addEventListener("touchend", (e: Event) => this.NP.events.cardSliderSwipeEnd(e));
                cardContainer.classList.toggle("allow-animation", true);
            });

            if (cardSliders.length > 0) {
                this.NP.registerResizeFunction("cardSlider", cardSliderResize);
            }
        };
    }
}